import * as React from 'react';

import { useLiveRef } from '@gitbook/util-react-hooks';

import { InteractionLocks, useFirstResponderInteraction } from '../Interactive';

/**
 * Detect when user is pressing the escape key to close an overlay.
 */
export function usePressEscape(onClose: undefined | (() => void)) {
    const onCloseRef = useLiveRef(onClose);
    const onCloseDefined = !!onClose;

    const isFirstEscapeResponder = useFirstResponderInteraction(
        InteractionLocks.KEYBOARD_ESCAPE,
        onCloseDefined
    );

    // Close on escape
    React.useEffect(() => {
        if (!isFirstEscapeResponder || !onCloseDefined) {
            return;
        }

        const onDocumentKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape' && !event.defaultPrevented) {
                event.preventDefault();
                onCloseRef.current?.();
            }
        };

        document.addEventListener('keydown', onDocumentKeyDown);
        return () => {
            document.removeEventListener('keydown', onDocumentKeyDown);
        };
    }, [isFirstEscapeResponder, onCloseRef, onCloseDefined]);
}
